import { useLingui } from "@lingui/react/macro";
import { Search, X } from "lucide-react";

import type { DataTableInstance } from "../../table-features";
import type { TextFilterField } from "../types";

import { getTextValue, setText } from "../tanstack-bridge";

export function TextEditor<T>({
  table,
  field,
  autoFocus,
  onSubmit,
}: {
  table: DataTableInstance<T>;
  field: TextFilterField<T>;
  autoFocus?: boolean;
  onSubmit?: () => void;
}) {
  const { t } = useLingui();
  const { query } = getTextValue(table, field);
  return (
    <div className="border-input flex h-8 items-center gap-2 rounded-lg border px-3">
      <Search size={16} className="shrink-0 opacity-50" />
      <input
        autoFocus={autoFocus}
        value={query}
        placeholder={field.placeholder ?? t`Search…`}
        onChange={(e) => setText(table, field, e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onSubmit?.();
          }
        }}
        className="flex-1 bg-transparent border-0 outline-none text-sm placeholder:text-muted-foreground min-w-0"
      />
      {query && (
        <button
          type="button"
          onClick={() => setText(table, field, "")}
          className="inline-flex p-0.5 bg-transparent border-0 text-muted-foreground/80 hover:text-brand-primary cursor-pointer"
          aria-label={t`Clear`}
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
}
